import React from "react";
import { PublicElevatedSection } from "sprint-common-web";

import { PublicDefaultLayout } from "../../../common/ui/layout/PublicDefaultLayout";
import { GenerateAccessKeyContent } from "./components/GenerateAccessKeyContent";
import { useGenerateAccessKeyPage } from "./useGenerateAccessKeyPage";

export const GenerateAccessKeyPage: React.VFC = () => {
    const {
        isAccessKeyGenerating,
        deliveryBucketInfo,
        isLoading,
        validationResult,
        accessKey,
        generateBucketAccessKey
    } = useGenerateAccessKeyPage();

    const handleGenerateAccessKey = async () => {
        generateBucketAccessKey();
    };

    return (
        <PublicDefaultLayout>
            <PublicElevatedSection headerText="Welcome to Sprint" width={400}>
                <GenerateAccessKeyContent
                    isLoading={isLoading}
                    bucketName={deliveryBucketInfo.name}
                    isAccessKeyGenerating={isAccessKeyGenerating}
                    validationResult={validationResult}
                    accessKeyInfo={accessKey}
                    onClick={handleGenerateAccessKey}
                />
            </PublicElevatedSection>
        </PublicDefaultLayout>
    );
};
